import SxDef from '@core/types/SxDef';
import menuScrollbar from '../../scrollbar';

const useSx = (): SxDef => ({
  root: {
    zIndex: 10000,
    '& .MuiPaper-root': {
      overflow: 'auto',
      ...menuScrollbar,
    },
  },
});

export default useSx;
